import { type ValueOf } from '@ezugi/types/utils';

// amount formatting options
export const AMOUNT_FORMAT_TYPES = {
  COMMA: 'comma',
  ENTIRE: 'entire',
  LETTER: 'letter',
  EXTEND_LETTER: 'extend_letter',
  EXTEND_LETTER_CHIP: 'extend_letter_chip',
} as const;

// amount types, each will be treated differently
export const AMOUNT_TYPES = {
  BET: 'bet',
  LIMIT: 'limit',
  CHIP: 'chip',
} as const;

export type AmountFormat = ValueOf<typeof AMOUNT_FORMAT_TYPES>;
export type AmountType = ValueOf<typeof AMOUNT_TYPES>;
